export default "__VITE_ASSET__DSuuPzNa__"